export enum LoaderActionTypes {
    ACTION_SHOW = 'ACTION_SHOW',
    ACTION_HIDE = 'ACTION_HIDE',
    ACTION_PENDING = 'ACTION_PEDING',
    ACTION_DONE = 'ACTION_DONE',
  }
  